import DashboardCard from 'containers/Dashboard/components/DashboardCard';
import Character from 'assets/images/characters/CarolinaMariadeJesus/default-happily.webp';
import SidebarLayout from 'layouts/SidebarLayout';
import Header from 'containers/NewReviewed/components/Header';
import {useNavigate} from 'react-router-dom';
import {fetchActivitiesRequest} from 'APIs/letrusAPI/activities';
import CTACarousel from 'containers/Dashboard/CTABanners/CTABannersCarousel';
import styles from '../Dashboard/Dashboard.module.scss';

function C5Dashboard() {
  const navigate = useNavigate();

  const {data: activities} = fetchActivitiesRequest();

  const isEmptyOpenActivities =
    activities?.in_progress?.length === 0 && activities?.opened.length === 0;
  const isEmptyScheduleActivities = activities?.scheduled?.length === 0;
  const isEmptyFinishedActivities =
    activities?.finished?.length === 0 &&
    activities?.reviewed?.length === 0 &&
    activities?.expired?.length === 0;
  const areAllActivitiesEmpty =
    isEmptyOpenActivities &&
    isEmptyFinishedActivities &&
    isEmptyScheduleActivities;

  return (
    <SidebarLayout>
      <main className={styles.wrapper}>
        <Header
          title="Exercícios Recomendados"
          subtitle="Aqui você encontrará exercícios para praticar e aperfeiçoar competências importantes para seu desenvolvimento em escrita e/ou leitura."
          onGoBack={() => navigate(-1)}
        />

        <CTACarousel />

        <ul className={styles.activityList}>
          {areAllActivitiesEmpty ? (
            <div className={styles.allEmptyActivities}>
              <figure aria-hidden>
                <img src={Character} alt="Carolina MariadeJesus" />
              </figure>
              <strong>
                Você não possui nenhuma atividade no momento. Volte em breve!
              </strong>
            </div>
          ) : (
            <>
              <li>
                <h2>Atividades abertas</h2>
                <ul>
                  {isEmptyOpenActivities && (
                    <div className={styles.emptyActivities}>
                      <strong>
                        Você não possui nenhuma atividade aberta no momento
                      </strong>
                    </div>
                  )}

                  {activities?.in_progress
                    ?.filter(
                      (activity) => activity?.learning_path_type === 'special',
                    )
                    ?.map((inProgressActivity) => (
                      <DashboardCard
                        activity={inProgressActivity}
                        key={inProgressActivity.id}
                      />
                    ))}

                  {activities?.opened
                    ?.filter(
                      (activity) => activity?.learning_path_type === 'special',
                    )
                    ?.map((openedActivity) => (
                      <DashboardCard
                        activity={openedActivity}
                        key={openedActivity.id}
                      />
                    ))}
                </ul>
              </li>

              <li>
                <h2>Atividades agendadas</h2>
                <ul>
                  {isEmptyScheduleActivities ? (
                    <div className={styles.emptyActivities}>
                      <strong>
                        Você não possui nenhuma atividade agendada no momento
                      </strong>
                    </div>
                  ) : (
                    activities?.scheduled
                      ?.filter(
                        (activity) =>
                          activity?.learning_path_type === 'special',
                      )
                      ?.map((scheduledActivity) => (
                        <DashboardCard
                          activity={scheduledActivity}
                          key={scheduledActivity.id}
                        />
                      ))
                  )}
                </ul>
              </li>

              <li>
                <h2>Atividades passadas</h2>
                <ul>
                  {isEmptyFinishedActivities && (
                    <div className={styles.emptyActivities}>
                      <strong className={styles.lastEmptyActivities}>
                        Você não possui nenhuma atividade passada no momento
                      </strong>
                    </div>
                  )}

                  {activities?.finished
                    ?.filter(
                      (activity) => activity?.learning_path_type === 'special',
                    )
                    ?.map((finishedActivity) => (
                      <DashboardCard
                        activity={finishedActivity}
                        key={finishedActivity.id}
                      />
                    ))}

                  {activities?.reviewed
                    ?.filter(
                      (activity) => activity?.learning_path_type === 'special',
                    )
                    ?.map((reviewedActivity) => (
                      <DashboardCard
                        activity={reviewedActivity}
                        key={reviewedActivity.id}
                      />
                    ))}

                  {activities?.expired
                    ?.filter(
                      (activity) => activity?.learning_path_type === 'special',
                    )
                    ?.map((expiredActivity) => (
                      <DashboardCard
                        activity={expiredActivity}
                        key={expiredActivity.id}
                      />
                    ))}
                </ul>
              </li>
            </>
          )}
        </ul>
      </main>
    </SidebarLayout>
  );
}

export default C5Dashboard;
